const card = {
    state: {
      iccids: sessionStorage.getItem("key_iccids"),
      poolCardIccids:undefined,
      productIccids:undefined
    },
    mutations: {
      SET_CACHE_ICCID:(state,iccids)=>{
        state.iccids = iccids;
        sessionStorage.setItem("key_iccids",iccids);
      },
      CLEAR_CACHE_ICCID:(state)=>{
        state.iccids = undefined;
        sessionStorage.removeItem("key_iccids");
      },
      SET_CACHE_PRODUCT_ICCID:(state,iccids)=>{
        state.productIccids = iccids;
      },
      CLEAR_CACHE_PRODUCT_ICCID:(state)=>{
        state.productIccids = undefined;
      },
      SET_CACHE_POOL_ICCID:(state,iccids)=>{
        state.poolCardIccids = iccids;
      },
      CLEAR_CACHE_POOL_ICCID:(state)=>{
        state.poolCardIccids = undefined;
      },
    },
    actions: {
        CacheIccids({ commit }, iccids) {
            commit('SET_CACHE_ICCID', iccids)  
        },
        ClearIccids({ commit }) {
            commit('CLEAR_CACHE_ICCID')  
        },
        CacheProductIccids({ commit }, iccids) {
          commit('SET_CACHE_PRODUCT_ICCID', iccids)  
        },
        ClearProductIccids({ commit }) {
            commit('CLEAR_CACHE_PRODUCT_ICCID')  
        },
        CachePoolIccids({ commit }, iccids) {
            commit('SET_CACHE_POOL_ICCID', iccids)  
        },
        ClearPoolIccids({ commit }) {
            commit('CLEAR_CACHE_POOL_ICCID')
        },
    }
  }
  
  export default card